
  import {defineComponent} from "vue";

  export default defineComponent({
    name: "no-search-result-component",
    methods: {

    },
    computed: {

    }
  });
